import { NavigationTranslationType, ProfileTranslationType, ErrorsTranslationType, CommonTranslationType } from "../../features/types";

// Remove nested structure type and export a flatter object structure
export const common = {
  navigation: {
    dashboard: "Tableau de Bord",
    profile: "Profil",
    signOut: "Déconnexion"
  },
  profile: {
    title: "Profil",
    dangerZone: "Zone Dangereuse",
    deleteAccount: "Supprimer le Compte",
    confirmDelete: "Confirmer la Suppression",
    deleteWarning: "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action ne peut pas être annulée.",
    confirmDeleteButton: "Supprimer le Compte",
    accountDeleted: "Compte Supprimé",
    accountDeletedMessage: "Votre compte a été supprimé avec succès."
  },
  cancel: "Annuler",
  delete: "Supprimer",
  deleteConfirmation: "Confirmer la Suppression",
  deleteConfirmationMessage: "Êtes-vous sûr de vouloir supprimer",
  confirm: "Confirmer",
  errors: {
    error: "Erreur",
    notFound: "Page non trouvée",
    deleteAccountError: "Une erreur s'est produite lors de la suppression de votre compte. Veuillez réessayer.",
    loadStoryError: "Échec du chargement de l'histoire. Veuillez réessayer.",
    loadCharactersError: "Échec du chargement des personnages. Veuillez réessayer.",
    summaryError: "Erreur lors de la génération du résumé. Veuillez réessayer."
  }
};
